import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { globalConfig } from './slices';
import { userProfile } from './profileSlice';
import { allProjectsSlice } from './projectSlice';
import { filtersSlice } from './filterSlice';
import timelineSlice from './timeline/timelineSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

const rootReducer = combineReducers({
  globalConfig: globalConfig.reducer,
  userProfile: userProfile.reducer,
  projects: allProjectsSlice.reducer,
  filters: filtersSlice.reducer,
  timeline: timelineSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useReduxDispatch = (): AppDispatch => useDispatch<AppDispatch>();

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['timeline/pending', 'timeline/fulfilled'],
        ignoredPaths: ['timeline.data'],
      },
    }),
});

export default store;
